import styled, { CSSProperties } from 'styled-components'
import { animated } from 'react-spring'

import { Button } from '@sketch/components'
import { ForwardRefExoticComponent } from 'react'

export const StyledButton = styled(Button)`
  flex: 1;
  position: relative;
`

export const CopiedCodesButtonText = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.state.positive.A};

  svg {
    margin-right: 4px;
  }
`

export const CopyText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const UnstyledAnimatedDiv = animated.div as ForwardRefExoticComponent<{
  children: React.ReactElement
  style: CSSProperties
}>

export const AnimatedDiv = styled(UnstyledAnimatedDiv)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
